import {AnswerModel} from './AnswerModel.js';
import {AnswerOption} from './AnswerOption.js';
import {AnswerPoll} from './AnswerPoll.js';
import {AnswerQuestion} from './AnswerQuestion.js';
import {Audience} from './Audience.js';
import {ChatConnect} from './ChatConnect.js';
import {Eventify} from './Eventify.js';
import {PollAdminControl} from './PollAdminControl.js';
import {PollEdit} from './PollEdit.js';
import {PollFolderItem} from './PollFolderItem.js';
import {PollFolderList} from './PollFolderList.js';
import {PollFolderModel} from './PollFolderModel.js';
import {PollModel} from './PollModel.js';
import {PollResultsUpdate} from './PollResultsUpdate.js';
import {PollResultsUpdateContainer} from './PollResultsUpdateContainer.js';
import {PollRobotLogin} from './PollRobotLogin.js';
import {PollRobotTemplate} from './PollRobotTemplate.js';
import {AskResultViewer} from './ResultAskModel.js';
import {VeedoDrop} from './VeedoDrop.js';
import {VeejayAdmin} from './VeejayAdmin.js';
import {VeejayAdminChannel} from './VeejayAdminChannel.js';
import {VeejayAudience} from './VeejayAudience.js';
import {VeejayResources} from './VeejayResources.js';

class Public {
	constructor() {
		//PollEdit.init();
		Audience.init();
		// ChatConnect.init();  // unsure what this was meant to be - currently an outline of something...?
		VeejayAudience.init(document);
	}
}

document.addEventListener(`DOMContentLoaded`, function() {
	console.log(`Public.js:: DOMContentLoaded`);
	new Public();
});



